var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Information Security Management",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Information "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Security Management ")]), _c('p', [_vm._v(" Proactively manage and protect your information and assets. "), _c('br'), _vm._v(" Systematically manage the history of data that is exported or brought in by using a security program. ")])])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Document Centralization"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/wwd/information/info-img1-en.png",
      "max-width": "950"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Security document grading"
    }
  }, [_c('p', {
    staticClass: "page-text dot-txt color-grey-2c mb-8 mb-lg-14"
  }, [_vm._v(" Operated by giving a "), _c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("Security Level")]), _vm._v(" for each folder ")]), _c('div', {
    staticClass: "w-100 border pa-20 pa-md-30 pt-lg-38 pb-lg-60 mb-18 mb-lg-34"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/wwd/information/info-img2-en.png",
      "max-width": "709"
    }
  })], 1), _c('p', {
    staticClass: "page-text dot-txt color-grey-2c mb-8 mb-lg-14"
  }, [_vm._v(" 정보자산 중요도 ")]), _c('table', {
    staticClass: "client-table w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "47%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Division")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Level")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Value")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Evaluation Scope")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Contents")])])])]), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Information Asset Importance")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Lv. 1")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("1")])]), _c('td', [_c('div', {
    staticClass: "table-inner color-point font-weight-bold"
  }, [_vm._v("8~9 Points")])]), _c('td', [_c('div', {
    staticClass: "table-inner left px-xl-40"
  }, [_vm._v("Core assets necessary to conduct business")])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Lv. 2")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2")])]), _c('td', [_c('div', {
    staticClass: "table-inner color-point font-weight-bold"
  }, [_vm._v("5~7 Points")])]), _c('td', [_c('div', {
    staticClass: "table-inner left px-xl-40"
  }, [_vm._v("Key assets that affect business performance")])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Lv. 3")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3")])]), _c('td', [_c('div', {
    staticClass: "table-inner color-point font-weight-bold"
  }, [_vm._v("3~4 Points")])]), _c('td', [_c('div', {
    staticClass: "table-inner left px-xl-40"
  }, [_vm._v("Core assets and general assets that support them")])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "PC with security program applied"
    }
  }, [_c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon1.png",
      "iconWidth": "48"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" After blocking/controlling the local PC storage of documents, transfer them to a central server, central management of corporate documents. ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" Prevents ransomware infection in advance by not leaving documents on the user's PC ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon2.png",
      "iconWidth": "50"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" External hard drive, screen capture, USB control, CD Rom control, print control, attachment control, shared folder control and remote program access control ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" Internal/external file access control through IP policy ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon3.png",
      "iconWidth": "48"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" Support for collaboration only for files paid by the file export transfer payment system ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" Document history management with multi-level payment system ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon4.png",
      "iconWidth": "50"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" Protection of corporate document assets through file encryption in central server storage and personal information encryption ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" Computer virus treatment and removal through real-time scanning ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon5.png",
      "iconWidth": "54"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" Save large files and avoid speed issues by designating a local area ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" Supports file backup and capacity setting in the secure drive area ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/information/info-icon6.png",
      "iconWidth": "52"
    }
  }, [_c('p', {
    staticClass: "dot-txt sm grey-2c mb-4 mb-lg-12"
  }, [_vm._v(" Detection of specific security keywords set by the title, personal information inserted in the body, and corporate policy ")]), _c('p', {
    staticClass: "dot-txt sm grey-2c"
  }, [_vm._v(" When detected, the document is quarantined to block leakage to the outside and file quarantine alarm function ")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }